import type { AddressSearchType } from './types'

// Exhaustive by type; (cities)/(regions) are Google collection tokens, not filterable types.
const NO_ADDRESS_MEMBERSHIP: Record<AddressSearchType, boolean> = {
  address: false,
  postcode: true,
  city: true,
  region: true,
  street: true,
  neighborhood: true,
  country: true,
  district: true,
  place: true,
  locality: true,
  block: true,
  '(cities)': false,
  '(regions)': false
}

function isAddressSearchType(key: string): key is AddressSearchType {
  return Object.hasOwn(NO_ADDRESS_MEMBERSHIP, key)
}

export const ALL_ADDRESS_SEARCH_TYPES: readonly AddressSearchType[] =
  Object.keys(NO_ADDRESS_MEMBERSHIP).filter(isAddressSearchType)
